import React, {useState} from "react";

/* ---------- COLORS ---------- */
const LEVEL_COLORS = {
    "FOLK FOUNDATION": "#dc3545", // Red
    "FOLK PRELIMS": "#ffc107", // Yellow
    "FOLK ENHANCED": "#198754", // Teal
    "FOLK GRADUATE": "#0d6efd", // Blue
    "FOLK PLUS": "#c14290ff", // Purple
};

/* ---------- SHORT LABELS ---------- */
const SHORT_LABELS = {
    "FOLK FOUNDATION": "Found",
    "FOLK PRELIMS": "Pre",
    "FOLK ENHANCED": "Enh",
    "FOLK GRADUATE": "Grad",
    "FOLK PLUS": "Plus",
};

const VALID_LEVELS = ["FOLK FOUNDATION", "FOLK PRELIMS", "FOLK ENHANCED", "FOLK GRADUATE", "FOLK PLUS"];

export default function FOLKLevelWiseReport({data, getTodayDate, onClose}) {
    const [isOpen, setIsOpen] = useState(!!data);
    if (!data || !isOpen) return null;

    const closeReport = () => {
        setIsOpen(false);
        onClose && onClose();
    };

    /* ---------- SUM COUNTS PER LEVEL ---------- */
    const levelTotals = VALID_LEVELS.reduce((acc, level) => {
        const guides = data.summary[level] || {};
        acc[level] = Object.values(guides).reduce((sum, count) => sum + count, 0);
        return acc;
    }, {});

    const maxValue = Math.max(...Object.values(levelTotals), 1);

    return (
        <div style={{textAlign: "center"}}>
            <div
                style={{
                    position: "relative",
                    background: "#f8f9fa",
                    padding: 20,
                    borderRadius: 12,
                    border: "1px solid #dee2e6",
                    maxWidth: "100%",
                    margin: "0 auto",
                    boxSizing: "border-box",
                }}
            >
                {/* CLOSE BUTTON */}
                <button
                    onClick={closeReport}
                    style={{
                        position: "absolute",
                        top: 14,
                        right: 14,
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        border: "none",
                        cursor: "pointer",
                        fontSize: 18,
                        fontWeight: "bold",
                        background: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,.15)",
                    }}
                >
                    ×
                </button>

                <h3 style={{marginBottom: 4}}>📊 FOLK Level Wise Attendance</h3>
                <div style={{color: "#666", fontSize: 14, marginBottom: 14}}>{getTodayDate()}</div>

                {/* BAR CHART */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        gap: 10,
                        height: 260,
                        background: "#fff",
                        border: "1px solid #e9ecef",
                        borderRadius: 8,
                        padding: 14,
                        overflowX: "auto",
                    }}
                >
                    {VALID_LEVELS.map((level) => {
                        const count = levelTotals[level] || 0;
                        const height = Math.max((count / maxValue) * 160, 18);

                        return (
                            <div
                                key={level}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: 38, // same as OntimeReport
                                }}
                            >
                                <div style={{fontWeight: "bold", fontSize: 13, marginBottom: 4}}>{count}</div>
                                <div
                                    style={{
                                        width: 34,
                                        height,
                                        background: LEVEL_COLORS[level] || "#999",
                                        borderRadius: "6px 6px 0 0",
                                    }}
                                />
                                <div
                                    style={{
                                        marginTop: 6,
                                        fontSize: 11,
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        textAlign: "center",
                                    }}
                                >
                                    {SHORT_LABELS[level]}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* FOOTER */}
                <div
                    style={{
                        marginTop: 14,
                        padding: 10,
                        background: "#d1ecf1",
                        borderRadius: 6,
                        fontWeight: "bold",
                        color: "#0c5460",
                        textAlign: "center",
                    }}
                >
                    Overall Total: {data.overallTotal}
                </div>
            </div>
        </div>
    );
}
